import React, { useEffect, useState } from 'react';

export default function Loader({ messages = ['Loading'] }) {
  const [i, setI] = useState(0);
  useEffect(() => {
    if (messages.length < 2) return;
    const t = setInterval(() => setI((p) => (p + 1) % messages.length), 1400);
    return () => clearInterval(t);
  }, [messages.length]);

  return (
    <div className="loader-overlay">
      <div className="orbit">
        <div className="ring r1" />
        <div className="ring r2" />
        <div className="ring r3" />
        <div className="core">
          <div className="bars"><i /><i /><i /><i /></div>
        </div>
      </div>
      <div className="loader-text">{messages[i]}</div>
    </div>
  );
}
